import { useDispatch, useSelector } from 'react-redux'
import { onLogout } from '../../redux/slices/meta'
import { clearUserData } from '../../redux/slices/user'
import { RootState } from '../../redux/store'
import { ViewTypes } from '../../types/state'
import {
	HeaderWrapper,
	Image,
	ImageWrapper,
	LogoutWrapper,
	// DownloadBanner,
} from './style'
import ProgressBar from '../ProgressBar'
import lenskartBlueLogo from '../../asset/lenskart_white_logo.png'
import { resetTranslations } from '../../redux/slices/translation'

const Header = () => {
	const dispatch = useDispatch()
	const metaData = useSelector((state: RootState) => state.meta)
	// const offerData = useSelector((state: RootState) => state.offers)
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)
	const logout = () => {
		dispatch(onLogout())
		dispatch(clearUserData())
		dispatch(resetTranslations())
	}
	// const { DOWNLOAD_STRIP_LINK, DOWNLOAD_STRIP_LOGO } = offerData

	return (
		<>
			<HeaderWrapper>
				<ImageWrapper>
					<div>
						<a
							href="https://www.lenskart.com/"
							target="_blank"
							rel="noreferrer"
						>
							<Image
								src={lenskartBlueLogo}
								alt={translations.LOGO_ALT}
							/>
						</a>
					</div>
					{metaData.isLogin && (
						<LogoutWrapper onClick={logout}>Logout</LogoutWrapper>
					)}
				</ImageWrapper>
				{metaData.view === ViewTypes.USER_INFO && <ProgressBar />}
				{/* {metaData.view === ViewTypes.OFFERS &&
					metaData.platform === PlatFormTypes.MWEB && (
						<a href={DOWNLOAD_STRIP_LINK}>
							<DownloadBanner
								src={DOWNLOAD_STRIP_LOGO}
								alt="Download banner"
							/>
						</a>
					)} */}
			</HeaderWrapper>
		</>
	)
}

export default Header
